import Uppy from '@uppy/core';
import { DashboardModal } from '@uppy/react';
import React from 'react';

import { useSciDomain } from 'components';
import { CLARITY_MASK_PROPS } from 'constants/clarity.constants';
import { SciThemeToUppyDialogMap } from 'enums';

import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@uppy/webcam/dist/style.min.css';

type Props = {
  open: boolean;
  uppy: Uppy;
  onClose: () => void;
};

export const DefaultUploadReceiptDialog: React.FC<Props> = ({
  open,
  uppy,
  onClose,
}) => {
  const { data: { theme } = {} } = useSciDomain();
  const modalTheme = theme ? SciThemeToUppyDialogMap[theme] : 'dark';

  return (
    <DashboardModal
      open={open}
      uppy={uppy}
      plugins={['Webcam']}
      proudlyDisplayPoweredByUppy={false}
      onRequestClose={onClose}
      theme={modalTheme}
      {...CLARITY_MASK_PROPS}
    />
  );
};
